import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { useAction } from 'core/store/store';

import { makeOnboardingSetPasswordAction, makeOnboardingSkipPasswordAction } from 'state/onboarding/actions';

import { Dialog } from 'components/Dialog/Dialog';

import { FinishOnboardingForm } from 'forms/FinishOnboardingForm/FinishOnboardingForm';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
}));

export const FinishRegistrationDialog = () => {
    const action = useAction();

    const handleSubmit = useCallback((data: { password: string }) => {
        action(makeOnboardingSetPasswordAction, data.password);
    }, []);

    const handleSkip = useCallback(() => {
        action(makeOnboardingSkipPasswordAction);
    }, []);

    const classes = useStyles();
    return (
        <Dialog contentStyles={classes.container}>
            <FinishOnboardingForm onSubmit={handleSubmit} onSkip={handleSkip} />
        </Dialog>
    );
};
